/* eslint-disable no-throw-literal */
import { initializeApp } from 'firebase/app';
import { getToken, getMessaging, onMessage } from 'firebase/messaging';

const firebaseConfig = {
  apiKey: "AIzaSyBVzfS1qrCc9HPppDwxoJCgMl8D8Us_m34",
  authDomain: "arianapars-pwa-4d5d2.firebaseapp.com",
  projectId: "arianapars-pwa-4d5d2",
  storageBucket: "arianapars-pwa-4d5d2.appspot.com",
  messagingSenderId: "109785667388",
  appId: "1:109785667388:web:8fff418acc6bd33278b039",
  measurementId: "G-WXXY51WXBX"
};

console.log('*** Firebase Config ***', firebaseConfig)

const app = initializeApp(firebaseConfig);
const messaging = getMessaging(app);

export const requestPermission = () => {

  console.log("Requesting User Permission......");
  Notification.requestPermission().then((permission) => {

    if (permission === "granted") {

      console.log("Notification User Permission Granted."); 
      return getToken(messaging, { vapidKey: 'BIkRjsB8gUm_P_liRi3KJ3W3WQz447L5z5kBLM0IVCVM6N-3qqwHgAPNyHYmy9yq7hUG0X1hjVeZ4bgiz_aP3Ug' })
        .then((currentToken) => {
          console.log('currentToken', currentToken);
          if (currentToken) {
            subscribeTokenToTopic(currentToken, 'all')
            console.log('Client Token: ', currentToken);
          } else {
            
            console.log('Failed to generate the app registration token.');
          }
        })
        .catch((err) => {

          console.log('An error occurred when requesting to receive the token.', err);
        });
    } else {

      console.log("User Permission Denied.");
    }
  });

}
requestPermission();

export const onMessageListener = () =>
  new Promise((resolve) => {
    onMessage(messaging, (payload) => {
      resolve(payload);
    });
});

const subscribeTokenToTopic = (token, topic) => 
{
  fetch('https://iid.googleapis.com/iid/v1/'+token+'/rel/topics/'+topic, {
    method: 'POST',
    headers: new Headers({
      'Authorization': 'key=AAAAGY-8Vzw:APA91bGFtEg5szk-uzEBAJmTiWvDocFng3gO4Io_HORNRTiHXGHir8TMbWHozkLWW-zcxyWbcHGVxkyraX1QCx23IopUMYDqtFsfCW8bR75a1RgO2qbgPF0sXEemDt9dQPDMZg54TP-l'
    })
  }).then(response => {
    if (response.status < 200 || response.status >= 400) {
      throw 'Error subscribing to topic: '+response.status + ' - ' + response.text();
    }
    console.log('Subscribed to "'+topic+'"');
  }).catch(error => {
    console.error(error);
  })
}
